import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import { MsalProvider } from '@azure/msal-react';
import {PublicClientApplication} from "@azure/msal-browser";
import {msalConfig} from "./msalConfig";

const AppShellMsalProvider = ({ children }) => {
  const pca = useMemo(() => new PublicClientApplication(msalConfig),
    [msalConfig])
  return <MsalProvider instance={pca}>{children}</MsalProvider>;
};

AppShellMsalProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default AppShellMsalProvider;